import styles from "./Row.module.sass";
import cn from "classnames";
import LetterAvatar from "../../../../components/LetterAvatar";
import { useNavigate } from "react-router-dom";
import Checkbox from "../../../../components/Checkbox";
import { getProspectById } from "../../../../services/prospect.service";

const Row = ({
    item,
    value,
    onChange,
    activeTable,
    setActiveTable,
    activeId,
    setActiveId
}) => {
    const navigate = useNavigate();

    const handleRowClick = async () => {
        try {
            // Récupérer les données complètes du prospect avant de naviguer
            const prospectData = await getProspectById(item.id, { expand: 'desired_formations,assigned_to' });
            navigate(`/admin/prospects_student/${item.id}`, { state: { prospect: prospectData } });
        } catch (error) {
            console.error('Erreur lors de la récupération des données du prospect:', error);
            // Naviguer quand même avec les données partielles
            navigate(`/admin/prospects_student/${item.id}`, { state: { prospect: item } });
        }
    };

    const handleClick = (id) => {
        setActiveTable(true);
        setActiveId(id);
    };

    const getStatusColor = (status) => {
        switch(status) {
            case 'Nouveau': return 'status-blue';
            case 'En cours': return 'status-blue';
            case 'Success': return 'status-yellow';
            case 'Hors cible': return 'status-red';
            case 'Créé': return 'status-green-dark';
            default: return 'status-gray';
        }
    };

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('fr-FR', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    
    return (
        <>
            <div className={styles.row} style={{ cursor: 'pointer' }}>
                <div className={styles.col}>
                    <Checkbox
                        className={styles.checkbox}
                        checked={value}
                        onChange={(e) => {
                            e.stopPropagation();
                            onChange(e);
                        }}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>

                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.item}>
                        <div className={styles.avatar}>
                            <LetterAvatar 
                                firstName={item.first_name}
                                lastName={item.last_name}
                                size={48}
                            />
                        </div>
                        <div className={styles.details}>
                            <div className={styles.user}>{`${item.first_name} ${item.last_name}`}</div>
                            <div className={styles.login}>
                              {(item.expand?.desired_formations && Object.keys(item.expand.desired_formations).length > 0) ? 
                                item.expand.desired_formations.exact_title_of_qualification : 
                                (item.desired_formations?.exact_title_of_qualification || 'Non spécifié')}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>{item.email}</div>
                    <div className={styles.phone}>{item.phone}</div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.email}>
                        {item.expand?.assigned_to?.name || 'Non assigné'}
                    </div>
                </div>
                                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={styles.date}>{item.last_contact_at ? formatDate(item.last_contact_at) : 'Aucun contact'}</div>
                </div>
                
                <div className={styles.col} onClick={handleRowClick}>
                    <div className={cn('status-type', getStatusColor(item.status))}>
                        {item.status}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Row;
